import { IotError } from "@core/domain/errors/iot.error.ts";
import type { Undefinable } from "@core/domain/types/undefinable.type";
import * as z from "zod";

const brandSchema = z.literal("ValidationError").brand<"ValidationError">();

export class ValidationError extends IotError {
    static readonly CODE = 400;

    readonly _brand = brandSchema;

    constructor(errors: Undefinable<Record<string, string[]>>) {
        const message = Object.entries(errors ?? {})
            .map(([key, value]) => `${key}: ${value.join("; ")}\n`)
            .join("");

        super(message);

        Object.setPrototypeOf(this, ValidationError.prototype);
    }
}
